import { AvatarBlock } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IGroup } from '../../interfaces/group';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';

export interface IGroupProfileProps {
    groupId: string;
    size: 'large' | 'small';
}

export function GroupProfile(props: IGroupProfileProps): JSX.Element {
    const abortableFetch = useAbortableFetch();
    const [group, setGroup] = useState<IGroup>();
    const { groupId, size } = props;

    useEffect(() => {
        loadGroup(groupId);
    }, [groupId]);

    if (!group) {
        return <></>;
    }

    return (
        <AvatarBlock
            backgroundColor="red"
            shape="circle"
            size={size}
            title={group.name}
        />
    );

    async function loadGroup(GroupId: string) {
        const url = `/api/groups/${GroupId}`;
        const result = await abortableFetch.fetchJson(url, 'GET');
        setGroup(result.json);
    }
}
